import { render, staticRenderFns } from "./paymentNotSupport.vue?vue&type=template&id=ea429a30&scoped=true"
import script from "./paymentNotSupport.vue?vue&type=script&lang=js"
export * from "./paymentNotSupport.vue?vue&type=script&lang=js"
import style0 from "./paymentNotSupport.vue?vue&type=style&index=0&id=ea429a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea429a30",
  null
  
)

export default component.exports